// import React, { useState, useEffect } from "react";
// import Footer from "./Footer";
// import Header from "./Header";
// import { URLS } from "../Url";
// import axios from "axios";
// import { Helmet } from "react-helmet";
// function About() {
//   const [About, setAbout] = useState([]);
//   const [AboutFeatures, setAboutFeatures] = useState([]);

//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     GetAboutdata();
//     GetAboutFeaturesdata();
//   }, []);

//   const GetAboutdata = () => {
//     axios.post(URLS.GetAbout, {}, {}).then((res) => {
//       if (res.status === 200) {
//         setAbout(res.data.aboutus);
//         setIsLoading(false);
//       }
//     });
//   };

//   const GetAboutFeaturesdata = () => {
//     axios.post(URLS.GetAboutFeatures, {}, {}).then((res) => {
//       if (res.status === 200) {
//         setAboutFeatures(res.data.features);
//       }
//     });
//   };
//   const BaseUrl = "https://api.carnivalcastle.com/v1/carnivalApi/";
//     const ImageBase = "https://api.carnivalcastle.com/";
  
//     const [addresses, setAddresses] = useState([]);
  
//     useEffect(() => {
//       const fetchAddresses = async () => {
//         try {
//           const res = await axios.get(`${BaseUrl}admin/address/alladdress`);
//           if (res.data && res.data.success) {
//             setAddresses(res.data.data || []);
//           } else {
//             setAddresses([]);
//           }
//         } catch (error) {
//           console.error("Error fetching addresses:", error);
//           setAddresses([]);
//         }
//       };
//       fetchAddresses();
//     }, []);
  

//   return (
//     <>
//       <Helmet>
//         <meta charSet="utf-8" />
//         <title>
//         Best Private Theater in Hyderabad | Carnival Castle
//         </title>
//         <meta
//           name="description"
//           content="Experience the magic of private theatre for your celebrations. Create unforgettable moments with exclusive screenings and personalized service just for you"
//         />
//       </Helmet>

//       {isLoading == true ? (
//         <>
//           <div
//             className="text-center"
//             style={{
//               // background:
//               //   "linear-gradient(329deg, rgba(191, 63, 249, 1) 0%, rgba(113, 51, 210, 1) 100%)",
//               backgroundColor: 'var(--charcoal-black)',
//               height: "100vh",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               flexDirection: "column",
//             }}
//           >
//             <div>
//             <img src="assets/img/gipss.gif" style={{ height: "300px", color:"white"}}></img>
//               <h6 style={{ color:"gold"}}>Loading...</h6>
//             </div>
//           </div>
//         </>
//       ) : (
//         <>
//           <div className="home-page indexsix">
//             <main className="main-wrapper">
//               <Header  />
//               <section
//                 id="parallax"
//                 className="slider-area breadcrumb-area d-flex align-items-center justify-content-center fix lighter-back"
//                 // style={{ backgroundImage: "url(img/bgss.jpg)" }}
//                 // style={{background: 'linear-gradient(329deg, rgba(191, 63, 249, 1) 0%, rgba(113, 51, 210, 1) 100%)'}}
//               >
//                 <div className="container">
//                   <div className="row">
//                     <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
//                       <div className="breadcrumb-wrap text-center">
//                         <div className="breadcrumb-title mb-30 dark-text">
//                           <h1 style={{ marginTop: "20px"  }}>About Us</h1>
//                         </div>
//                         {/* <nav aria-label="breadcrumb">
//                           <ol className="breadcrumb">
//                             <li className="breadcrumb-item">
//                               <a href="/">Home</a>
//                             </li>
//                             <li
//                               className="breadcrumb-item active"
//                               aria-current="page"
//                             >
//                               News
//                             </li>
//                           </ol>
//                         </nav> */}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </section>
//               <section className="pt-4 pb-4 p-relative lighter-back">
//               {/* <section className="pt-4 pb-4 p-relative mt-4"> */}
//                 <div className="container-md">
//                   <div className="row align-items-center">                    
//                     <div className="col-lg-6">
//                       <div className="">
//                         <h3 className="dark-text">
//                           <b> {About.title}</b>
//                         </h3>
//                       </div>
//                       <p className="light-text pt-3">
//                         {About.description}
//                       </p>
//                     </div>
//                     <div className="col-lg-6">
//                       <div>
//                         <img
//                           src={URLS.Base + About.image}
//                           alt="Testimonial"
//                           style={{
//                             borderRadius: "20px",
//                             height: "400px",
//                             width: "100%",
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </section>
//               <section className="bg-white" >
//                   <div className="container-fluid text-center py-5 lighter-back">
//                     <h2 className="fw-bold mb-5 dark-text">Our Branches</h2>

//                     <div className="row justify-content-center">
//                       {addresses.map((addr, idx) => (
//                         <div className="col-md-6 col-lg-5 mb-4" key={idx}>
//                           <div
//                             className="p-4 shadow-lg lighter-back h-100"
//                             style={{
//                               borderRadius: "2rem",
//                               transition: "0.3s",
//                             }}
//                           >
//                             <h4 className="fw-bold text-center mb-3" style={{ color: "#5b179b" }}>
//                               {addr.name}
//                             </h4>
//                             <p
//                               className="text-muted mb-3 text-center"
//                               style={{ fontStyle: "italic", fontSize: "0.95rem" }}
//                             >
//                               {addr.addressLine1}, {addr.addressLine2}
//                             </p>

//                             <div className="text-center">
//                               <a
//                                 href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
//                                   `${addr.addressLine1}, ${addr.addressLine2}`
//                                 )}`}
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 className="text-decoration-none fw-semibold"
//                                 style={{ color: "#6d28d9" }}
//                               >
//                                 <i className="bi bi-geo-alt-fill me-2 light-text"></i>See on map
//                               </a>
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   </div>


//                   <style jsx>{`
//                   .text-purple {
//                    color: #5b179b;
//                     }
//                  `}</style>
//                 </section>
//             </main>
//             <Footer />
//           </div>
//         </>
//       )}
//     </>
//   );
// }

// export default About;

import React, { useState, useEffect, memo } from "react";
import Footer from "./Footer";
import Header from "./Header";
import { URLS } from "../Url";
import axios from "axios";
import { Helmet } from "react-helmet";

const C = {
  primary:"#5E0E73", primaryLight:"#6E1A85", primaryDeep:"#3A0847",
  primaryPale:"#F3E5F7", cream:"#E8E1D6", beige:"#D6CFC4",
  gold:"#C9A84C", goldLight:"#E8D5A0", goldBright:"#F5D87A",
  dark:"#1A0030", dark2:"#120020",
};

/* ── Scroll reveal ── */
const ScrollReveal = memo(() => {
  useEffect(() => {
    const o = new IntersectionObserver(
      e => e.forEach(x => { if (x.isIntersecting) x.target.classList.add("ab-in"); }),
      { threshold: 0.08 }
    );
    const run = () => document.querySelectorAll(".ab-rv:not(.ab-in)").forEach(el => o.observe(el));
    run(); const t = setTimeout(run, 400);
    return () => { o.disconnect(); clearTimeout(t); };
  }, []);
  return null;
});

function About() {
  const [about,    setAbout]    = useState({});
  const [features, setFeatures] = useState([]);
  const [addresses,setAddresses]= useState([]);
  const [loading,  setLoading]  = useState(true);

  const BaseUrl  = "https://api.carnivalcastle.com/v1/carnivalApi/";

  useEffect(() => {
    const promises = [
      axios.post(URLS.GetAbout, {}).then(r => { if (r.status===200) setAbout(r.data.aboutus||{}); }),
      axios.post(URLS.GetAboutFeatures, {}).then(r => { if (r.status===200) setFeatures(r.data.features||[]); }),
      axios.get(`${BaseUrl}admin/address/alladdress`).then(r => { if (r.data?.success) setAddresses(r.data.data||[]); }),
    ];
    Promise.all(promises).finally(() => setLoading(false));
  }, []);

  /* ── Loading ── */
  if (loading) return (
    <div style={{ background:C.dark, height:"100vh", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:18 }}>
      <div style={{ width:68, height:68, border:`4px solid ${C.primaryPale}`, borderTop:`4px solid ${C.gold}`, borderRadius:"50%", animation:"_spin 1s linear infinite" }}/>
      <p style={{ color:C.gold, fontWeight:600, letterSpacing:2, fontSize:14 }}>Loading…</p>
      <style>{`@keyframes _spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );

  return (
    <>
      <Helmet>
        <title>Best Private Theater in Hyderabad | Carnival Castle</title>
        <meta name="description" content="Experience the magic of private theatre for your celebrations. Create unforgettable moments with exclusive screenings and personalized service just for you."/>
      </Helmet>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;0,900;1,600&family=DM+Sans:wght@300;400;500;600;700&display=swap');
        :root{--p:${C.primary};--pl:${C.primaryLight};--pd:${C.primaryDeep};--pp:${C.primaryPale};--cream:${C.cream};--beige:${C.beige};--gold:${C.gold};--gl:${C.goldLight};--gb:${C.goldBright};--dark:${C.dark};--dark2:${C.dark2};}
        *,*::before,*::after{box-sizing:border-box;}
        .ab-root,.ab-root *{font-family:'DM Sans',sans-serif;}
        .pf{font-family:'Playfair Display',serif!important;}

        @keyframes ab-fadeUp{from{opacity:0;transform:translateY(36px)}to{opacity:1;transform:translateY(0)}}
        @keyframes ab-float{0%,100%{transform:translateY(0)}50%{transform:translateY(-12px)}}
        @keyframes ab-shine{0%{left:-100%}25%{left:130%}100%{left:130%}}
        @keyframes ab-goldBg{0%,100%{background-position:0% 50%}50%{background-position:100% 50%}}
        @keyframes ab-ticker{from{transform:translateX(0)}to{transform:translateX(-50%)}}
        @keyframes ab-pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.03)}}
        @keyframes ab-spin{to{transform:rotate(360deg)}}

        /* scroll reveal */
        .ab-rv{opacity:0;transform:translateY(32px);transition:opacity .7s ease,transform .7s cubic-bezier(.16,1,.3,1);}
        .ab-rv.ab-in{opacity:1;transform:translateY(0);}
        .ab-rv.d1{transition-delay:.1s}.ab-rv.d2{transition-delay:.2s}.ab-rv.d3{transition-delay:.3s}

        /* ── Hero ── */
        .ab-hero{
          position:relative;min-height:62vh;overflow:hidden;
          background:linear-gradient(135deg,rgba(26,0,48,.82) 0%,rgba(94,14,115,.55) 50%,rgba(18,0,32,.85) 100%),
            url('https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=1200&q=80') center/cover no-repeat;
          display:flex;align-items:center;justify-content:center;text-align:center;
        }
        .ab-hero-orb{position:absolute;border-radius:50%;filter:blur(70px);pointer-events:none;}
        .ab-hero-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(201,168,76,.1);border:1px solid rgba(201,168,76,.32);backdrop-filter:blur(12px);border-radius:60px;padding:8px 20px;color:var(--gold);font-size:12px;font-weight:700;letter-spacing:1px;text-transform:uppercase;margin-bottom:20px;width:fit-content;}
        .ab-hero-title{font-family:'Playfair Display',serif;font-size:clamp(38px,6vw,72px);font-weight:900;color:#fff;line-height:1.07;margin-bottom:18px;text-shadow:0 4px 24px rgba(0,0,0,.35);}
        .ab-hero-title span{background:linear-gradient(135deg,var(--gl),var(--cream));-webkit-background-clip:text;-webkit-text-fill-color:transparent;}
        .ab-hero-sub{font-size:clamp(14px,2vw,17px);color:rgba(255,255,255,.68);max-width:520px;margin:0 auto 32px;}
        .ab-hero-divider{width:60px;height:2px;background:linear-gradient(90deg,transparent,var(--gold),transparent);margin:0 auto;}

        /* ── About section ── */
        .ab-about{padding:88px 0;background:var(--cream);}
        .ab-about-img-wrap{position:relative;border-radius:28px;overflow:hidden;box-shadow:0 40px 80px rgba(94,14,115,.18);}
        .ab-about-img{width:100%;height:460px;object-fit:cover;display:block;transition:transform .6s cubic-bezier(.25,1,.5,1);}
        .ab-about-img-wrap:hover .ab-about-img{transform:scale(1.04);}
        .ab-about-img-glow{position:absolute;inset:0;background:linear-gradient(to top,rgba(94,14,115,.22) 0%,transparent 55%);pointer-events:none;}
        .ab-about-float{position:absolute;background:#fff;border-radius:16px;padding:12px 18px;box-shadow:0 14px 36px rgba(0,0,0,.15);animation:ab-float 4s ease-in-out infinite;white-space:nowrap;}

        .ab-tag{display:inline-block;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;color:var(--gold);margin-bottom:12px;}
        .ab-h{font-family:'Playfair Display',serif;font-size:clamp(26px,4vw,42px);font-weight:700;line-height:1.2;color:var(--dark);}
        .ab-h span{color:var(--p);}
        .ab-underline{width:56px;height:3px;background:linear-gradient(90deg,var(--p),var(--gold));border-radius:2px;margin:16px 0 22px;}
        .ab-desc{font-size:15px;color:#555;line-height:1.85;}

        .ab-stat-row{display:flex;gap:28px;flex-wrap:wrap;margin-top:36px;}
        .ab-stat{text-align:center;}
        .ab-stat-n{font-family:'Playfair Display',serif;font-size:30px;font-weight:900;color:var(--p);line-height:1;}
        .ab-stat-l{font-size:11px;color:#888;text-transform:uppercase;letter-spacing:1px;margin-top:4px;}

        /* ── Features ── */
        .ab-feat-sec{padding:80px 0;background:#fff;}
        .ab-feat-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:24px;margin-top:52px;}
        @media(max-width:1024px){.ab-feat-grid{grid-template-columns:repeat(2,1fr);}}
        @media(max-width:600px){.ab-feat-grid{grid-template-columns:1fr;}}
        .ab-feat-card{border-radius:22px;padding:32px 26px;background:var(--pp);border:1px solid rgba(94,14,115,.08);transition:transform .4s cubic-bezier(.25,1,.5,1),box-shadow .4s;cursor:default;position:relative;overflow:hidden;}
        .ab-feat-card:hover{transform:translateY(-10px);box-shadow:0 24px 60px rgba(94,14,115,.14);}
        .ab-feat-card::before{content:'';position:absolute;top:0;right:0;width:80px;height:80px;border-radius:0 22px 0 80px;background:linear-gradient(135deg,rgba(94,14,115,.07),transparent);}
        .ab-feat-icon{font-size:36px;margin-bottom:16px;}
        .ab-feat-title{font-family:'Playfair Display',serif;font-size:17px;font-weight:700;color:var(--dark);margin-bottom:10px;}
        .ab-feat-desc{font-size:13px;color:#666;line-height:1.7;}

        /* ── Branches ── */
        .ab-branch-sec{
          padding:88px 0;
          background:linear-gradient(160deg,var(--dark) 0%,#2A0040 40%,var(--dark) 100%);
          position:relative;overflow:hidden;
        }
        .ab-branch-sec::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 70% 50% at 50% 50%,rgba(94,14,115,.2) 0%,transparent 70%);pointer-events:none;}
        .ab-branch-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:24px;margin-top:52px;}
        @media(max-width:768px){.ab-branch-grid{grid-template-columns:1fr;}}

        .ab-branch-card{
          border-radius:24px;
          background:rgba(255,255,255,.04);
          border:1px solid rgba(201,168,76,.18);
          padding:36px 32px;
          position:relative;overflow:hidden;
          transition:transform .4s cubic-bezier(.25,1,.5,1),box-shadow .4s,border-color .3s;
        }
        .ab-branch-card:hover{
          transform:translateY(-8px);
          box-shadow:0 28px 72px rgba(0,0,0,.4);
          border-color:rgba(201,168,76,.4);
        }
        .ab-branch-card::before{
          content:'';position:absolute;top:0;left:0;right:0;height:2px;
          background:linear-gradient(90deg,transparent,var(--gold),transparent);
          opacity:0;transition:opacity .3s;
        }
        .ab-branch-card:hover::before{opacity:1;}

        .ab-branch-num{
          position:absolute;top:20px;right:24px;
          font-family:'Playfair Display',serif;font-size:52px;font-weight:900;
          color:rgba(201,168,76,.06);line-height:1;pointer-events:none;user-select:none;
        }
        .ab-branch-icon{
          width:52px;height:52px;border-radius:14px;
          background:linear-gradient(135deg,rgba(201,168,76,.15),rgba(94,14,115,.15));
          border:1px solid rgba(201,168,76,.25);
          display:flex;align-items:center;justify-content:center;font-size:22px;
          margin-bottom:20px;transition:transform .3s;
        }
        .ab-branch-card:hover .ab-branch-icon{transform:scale(1.1) rotate(5deg);}
        .ab-branch-name{font-family:'Playfair Display',serif;font-size:20px;font-weight:700;color:#fff;margin-bottom:10px;}
        .ab-branch-addr{font-size:13px;color:rgba(255,255,255,.5);line-height:1.7;margin-bottom:20px;}
        .ab-branch-link{
          display:inline-flex;align-items:center;gap:8px;
          font-size:13px;font-weight:700;color:var(--gold);text-decoration:none;
          padding:9px 20px;border-radius:50px;
          border:1.5px solid rgba(201,168,76,.35);
          background:rgba(201,168,76,.07);
          transition:all .25s;
        }
        .ab-branch-link:hover{background:var(--gold);color:var(--dark);border-color:var(--gold);}

        /* ── CTA banner ── */
        .ab-cta{
          position:relative;overflow:hidden;
          background:linear-gradient(135deg,var(--pd) 0%,var(--p) 50%,var(--pd) 100%);
          background-size:300% 300%;animation:ab-goldBg 6s ease infinite;
          padding:72px 0;text-align:center;
        }
        .ab-cta::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 60% 80% at 50% 50%,rgba(201,168,76,.07) 0%,transparent 70%);pointer-events:none;}
        .ab-cta-h{font-family:'Playfair Display',serif;font-size:clamp(26px,4vw,44px);font-weight:900;color:#fff;margin-bottom:14px;}
        .ab-cta-h span{background:linear-gradient(135deg,var(--gl),var(--gb));-webkit-background-clip:text;-webkit-text-fill-color:transparent;}
        .ab-cta-sub{color:rgba(255,255,255,.6);font-size:15px;max-width:440px;margin:0 auto 30px;}
        .ab-cta-btn{
          position:relative;overflow:hidden;
          background:linear-gradient(135deg,#B8860B,var(--gold),var(--gb),var(--gold),#9A6E10);
          background-size:200% 200%;animation:ab-goldBg 3s ease infinite;
          color:var(--dark);border:none;border-radius:50px;padding:15px 36px;
          font-weight:800;font-size:15px;cursor:pointer;
          box-shadow:0 8px 28px rgba(201,168,76,.45);
          display:inline-flex;align-items:center;gap:10px;
          font-family:'DM Sans',sans-serif;transition:transform .3s,box-shadow .3s;
          text-decoration:none;
        }
        .ab-cta-btn::before{content:'';position:absolute;top:0;left:-100%;width:55%;height:100%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.4),transparent);animation:ab-shine 3s ease infinite;}
        .ab-cta-btn:hover{transform:translateY(-3px);box-shadow:0 14px 44px rgba(201,168,76,.6);color:var(--dark);}

        /* ── Ticker ── */
        .ab-ticker{background:var(--pd);padding:10px 0;overflow:hidden;border-bottom:1px solid rgba(201,168,76,.15);}
        .ab-ticker-track{display:flex;width:max-content;animation:ab-ticker 22s linear infinite;}
        .ab-ticker-item{color:rgba(255,255,255,.6);font-size:11px;font-weight:600;letter-spacing:1px;text-transform:uppercase;padding:0 40px;border-right:1px solid rgba(255,255,255,.1);white-space:nowrap;}

        /* ── Misc ── */
        .ab-wa-btn{background:#25D366;color:#fff;border:none;border-radius:50px;padding:14px 30px;font-weight:700;font-size:14px;cursor:pointer;transition:all .3s;text-decoration:none;display:inline-flex;align-items:center;gap:8px;box-shadow:0 6px 20px rgba(37,211,102,.3);font-family:'DM Sans',sans-serif;margin-left:14px;}
        .ab-wa-btn:hover{background:#1ebe5d;transform:translateY(-2px);color:#fff;}

        @media(max-width:768px){
          .ab-about{padding:52px 0;}
          .ab-about-img{height:280px;}
          .ab-feat-sec,.ab-branch-sec{padding:52px 0;}
          .ab-cta{padding:52px 0;}
          .ab-hero{min-height:52vh;}
          .ab-stat-row{gap:18px;}
        }
      `}</style>

      <ScrollReveal/>

      <div className="ab-root">
        <Header/>

        {/* ── Ticker ── */}
        <div className="ab-ticker"><div className="ab-ticker-track">
          {[...Array(4)].map((_,k)=>["🎭 Private Theatre Celebrations","⭐ 50k+ 5-Star Reviews","📍 Multiple Locations in Hyderabad","🎂 Birthdays · Anniversaries · Proposals","⚡ Book in 2 Minutes"].map((item,i)=>(
            <span key={`${k}-${i}`} className="ab-ticker-item">{item}</span>
          )))}
        </div></div>

        {/* ── Hero ── */}
        <section className="ab-hero">
          <div className="ab-hero-orb" style={{width:500,height:500,background:`radial-gradient(circle,${C.primary}36 0%,transparent 70%)`,top:-100,right:-80}}/>
          <div className="ab-hero-orb" style={{width:300,height:300,background:"radial-gradient(circle,rgba(201,168,76,.1) 0%,transparent 70%)",bottom:60,left:-60}}/>
          <div style={{position:"relative",zIndex:2,animation:"ab-fadeUp .9s cubic-bezier(.16,1,.3,1) both"}}>
            <div style={{display:"flex",justifyContent:"center"}}>
              <div className="ab-hero-badge">🎭 Hyderabad's Premier Private Theatre</div>
            </div>
            <h1 className="ab-hero-title pf">Our <span>Story</span></h1>
            <p className="ab-hero-sub">Where celebrations become cinematic memories — crafted with love, lit with gold.</p>
            <div className="ab-hero-divider"/>
          </div>
        </section>

        {/* ── About ── */}
        <section className="ab-about">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-6 ab-rv">
                <div className="ab-tag">✦ Who We Are ✦</div>
                <h2 className="ab-h pf">{about.title || "Creating Magical <span>Moments</span> Together"}</h2>
                <div className="ab-underline"/>
                <p className="ab-desc">{about.description || "Carnival Castle is Hyderabad's most loved private theatre celebration venue — a place where every birthday, anniversary, proposal, and special moment is transformed into a cinematic experience you'll treasure forever."}</p>
                <div className="ab-stat-row">
                  {[["50k+","Happy Guests"],["4.9★","Google Rating"],["15+","Unique Themes"],["3+","Locations"]].map(([n,l])=>(
                    <div key={l} className="ab-stat"><div className="ab-stat-n pf">{n}</div><div className="ab-stat-l">{l}</div></div>
                  ))}
                </div>
                <div style={{display:"flex",flexWrap:"wrap",gap:12,marginTop:32}}>
                  <a href="/locations" style={{background:`linear-gradient(135deg,${C.primary},${C.primaryLight})`,color:"#fff",border:"none",borderRadius:"50px",padding:"13px 28px",fontWeight:700,fontSize:14,cursor:"pointer",boxShadow:`0 6px 20px rgba(94,14,115,.35)`,textDecoration:"none",display:"inline-flex",alignItems:"center",gap:8}}>
                    🎉 Book a Celebration
                  </a>
                  <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="ab-wa-btn">
                    <i className="bi bi-whatsapp"/> WhatsApp Us
                  </a>
                </div>
              </div>
              <div className="col-lg-6 ab-rv d2">
                <div className="ab-about-img-wrap">
                  {about.image
                    ? <img src={URLS.Base + about.image} alt="About Carnival Castle" className="ab-about-img"/>
                    : <img src="https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=700&q=80" alt="About Carnival Castle" className="ab-about-img"/>
                  }
                  <div className="ab-about-img-glow"/>
                  <div className="ab-about-float d-none d-md-block" style={{bottom:28,left:-24,animationDelay:"0s"}}>
                    <div style={{fontSize:10,color:"#888",marginBottom:4,textTransform:"uppercase",letterSpacing:1}}>Est. in Hyderabad</div>
                    <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:18}}>🎭</span><div><div style={{fontSize:13,fontWeight:700,color:C.dark}}>Carnival Castle</div><div style={{fontSize:11,color:C.primary}}>Your Celebration Partner</div></div></div>
                  </div>
                  <div className="ab-about-float d-none d-md-block" style={{top:28,right:-24,animationDelay:"1.5s"}}>
                    <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:18}}>⭐</span><div><div style={{fontSize:13,fontWeight:700,color:C.dark}}>4.9 / 5.0</div><div style={{fontSize:11,color:"#888"}}>50k+ Reviews</div></div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── Features ── */}
        {features.length > 0 && (
          <section className="ab-feat-sec">
            <div className="container">
              <div className="text-center ab-rv" style={{marginBottom:0}}>
                <div className="ab-tag">✦ What Makes Us Special ✦</div>
                <h2 className="ab-h pf text-center">Why Guests <span>Love</span> Us</h2>
                <p style={{color:"#777",fontSize:15,maxWidth:500,margin:"12px auto 0"}}>Every detail crafted to make your celebration truly unforgettable.</p>
              </div>
              <div className="ab-feat-grid">
                {features.map((feat, i) => (
                  <div key={i} className={`ab-feat-card ab-rv d${(i%3)+1}`}>
                    <div className="ab-feat-icon">{["🎭","🎂","💍","🎵","📸","✨"][i] || "🌟"}</div>
                    <div className="ab-feat-title pf">{feat.title}</div>
                    <div className="ab-feat-desc">{feat.description}</div>
                  </div>
                ))}
                {features.length === 0 && [
                  {icon:"🎭",title:"Exclusive Private Theatre",desc:"Book the entire space just for your celebration — no strangers, no interruptions, just your people."},
                  {icon:"🎂",title:"Personalized Setups",desc:"From florals to fairy lights, every decoration is tailored to match your vision and occasion."},
                  {icon:"📸",title:"Professional Photography",desc:"Capture every smile, tear, and laugh with our professional photography and videography add-ons."},
                  {icon:"🎵",title:"Curated Entertainment",desc:"Custom playlists, surprise performances, and more — we make every moment feel like a movie."},
                  {icon:"💍",title:"Proposal Ready",desc:"Create the perfect setting for the most important question of your life — we handle every detail."},
                  {icon:"⭐",title:"5-Star Experience",desc:"Rated 4.9 stars across Google and Facebook — our guests' joy is our greatest achievement."},
                ].map((feat,i)=>(
                  <div key={i} className={`ab-feat-card ab-rv d${(i%3)+1}`}>
                    <div className="ab-feat-icon">{feat.icon}</div>
                    <div className="ab-feat-title pf">{feat.title}</div>
                    <div className="ab-feat-desc">{feat.desc}</div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* ── Branches ── */}
        {addresses.length > 0 && (
          <section className="ab-branch-sec">
            <div className="container" style={{position:"relative",zIndex:1}}>
              <div className="text-center ab-rv">
                <div className="ab-tag" style={{color:C.goldLight}}>✦ Find Us ✦</div>
                <h2 className="ab-h pf cc-h-white text-center" style={{color:"#fff"}}>Our <span style={{background:`linear-gradient(135deg,${C.goldLight},${C.goldBright})`,WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>Locations</span></h2>
                <p style={{color:"rgba(255,255,255,.5)",fontSize:15,maxWidth:480,margin:"12px auto 0"}}>Multiple venues across Hyderabad — find the one closest to you.</p>
              </div>
              <div className="ab-branch-grid">
                {addresses.map((addr, i) => (
                  <div key={i} className={`ab-branch-card ab-rv d${(i%2)+1}`}>
                    <div className="ab-branch-num">{String(i+1).padStart(2,"0")}</div>
                    <div className="ab-branch-icon">📍</div>
                    <div className="ab-branch-name pf">{addr.name}</div>
                    <div className="ab-branch-addr">{addr.addressLine1}{addr.addressLine2 ? `, ${addr.addressLine2}` : ""}</div>
                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${addr.addressLine1}, ${addr.addressLine2}`)}`}
                      target="_blank" rel="noopener noreferrer"
                      className="ab-branch-link"
                    >
                      <i className="bi bi-geo-alt-fill"/> See on Maps →
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* ── CTA ── */}
        <section className="ab-cta">
          <div className="container" style={{position:"relative",zIndex:1}}>
            <span style={{fontSize:52}}>🎉</span>
            <h2 className="ab-cta-h pf" style={{marginTop:14}}>Ready to Create <span>Pure Magic?</span></h2>
            <p className="ab-cta-sub">Book your private theatre celebration today and let us make it unforgettable.</p>
            <div style={{display:"flex",justifyContent:"center",gap:14,flexWrap:"wrap"}}>
              <a href="/locations" className="ab-cta-btn">🎭 Book a Celebration</a>
              <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="ab-wa-btn" style={{marginLeft:0}}>
                <i className="bi bi-whatsapp"/> Chat With Us
              </a>
            </div>
          </div>
        </section>

        <Footer/>
      </div>
    </>
  );
}

export default About;
